
export const BASE_URL = '/api/rest/v1/'

export const CLIENTS_ENDPOINT = 'clients'
export const DOCUMENTS_ENDPOINT = 'documents'
export const USERS_ENDPOINT = 'users'
export const WEBHOOKS_ENDPOINT = 'webhooks'

export const USER_META_COLLECTION_ID = '26'
